import React, { useEffect, useRef, useState, useReducer } from 'react'
import {
    Container, Typography, Box, Button, Grid, Stack, Tooltip, ListItemIcon, Paper
} from '@mui/material'
import { apiUrl } from '../../../utils/api';
import { useGetFoodDetailsQuery, useGetFoodActiveApiMutation, useGetFoodDeleteApiMutation, useGetFoodVerifiedApiMutation } from "../../../redux/services/seller/sellerInfo";
import { useGetvariantsApiMutation, useGetvariantsDeleteApiMutation } from '../../../redux/services/variant/variant';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import VariantTable from '../../variant/variantTable';
import Iconify from '../../../components/iconify/Iconify';
import CircularProgress from '@mui/material/CircularProgress';

import { AlertDialog } from '../../../utils/dealog/diloag';
import { FoodMenuEdite, } from '../components/MenuEdit';
import { FoodMenuCreate } from '../components/MenuCreate';
import { useGetCategoryQuery } from '../../../redux/services/common/Common';
import { showError, showSuccess } from '../../../utils/toast';
import UpdateVariant from '../../variant/updateVariant';
import AddVariant from '../../variant/addVariant';
import { sentenceCase } from 'change-case';
import Label from '../../../components/label/Label';
// eslint-disable-next-line import/no-unresolved


const DataLogo = ({ name, path }) => {
    const url = `${apiUrl.foodImg}${path}`;
    console.log('foodImg', url);
    return (
        <Box sx={{ padding: 2, marginRight: 2 }}>
            <Paper elevation={3} sx={{ display: "flex", justifyContent: 'center' }}>
                <img alt={name} src={url} style={{ height: "60%", width: "60%" }}
                />
            </Paper>
        </Box>
    )
}

const DeactivateButton = ({ food, onDeactivate, }) => (
    <>
        <Tooltip title="Deactivate">
            <Button onClick={() => onDeactivate(food)} >
                < ListItemIcon style={{ justifyContent: 'center' }}>
                    <Label color={("" === 'banned' && ' success') || 'error'}>{sentenceCase("deactive")}</Label>
                </ ListItemIcon>
            </Button>
        </Tooltip>
    </>
)

const ActivateButton = ({ food, onActivate, }) => (

    <>
        <Tooltip title="Activate">
            <Button onClick={() => onActivate(food)} >
                <    ListItemIcon style={{ justifyContent: 'center' }}>
                    <Label color={("" === 'banned' && 'error') || 'success'}>{sentenceCase("active")}</Label>
                </  ListItemIcon>
            </Button>
        </Tooltip>
    </>

)
const FoodVerified = ({ food, foodStatus, }) => (


    <>
        <Tooltip title="Verified" onClick={() => { foodStatus(food) }}>
            <Button >
                <ListItemIcon style={{ justifyContent: "center", }}>
                    <Label color={("" === 'banned' && 'error') || 'success'}>{sentenceCase("verified")}</Label>
                </ListItemIcon>
            </Button>
        </Tooltip>
    </>

)

const FoodNotVerified = ({ food, notfoodStatus }) => (
    <>        <Tooltip title="Not Verified" onClick={() => { notfoodStatus(food) }}>
        <Button >
            <ListItemIcon style={{ justifyContent: "center", }}>
                <Label color={("" === 'banned' && ' success') || 'error'}>{sentenceCase("not verified")}</Label>
            </ListItemIcon>
        </Button>
    </Tooltip>
    </>

)


const FoodDeital = ({ setFoodDetail, foodDetail, foodID, foodVarient, load, reLoad }) => {
    const getFoodId = foodID?.id
    const getSellerId = foodID?.seller?.id



    // redux Api Fatching
    const { data: getFoodDetails, isLoading, isSuccess } = useGetFoodDetailsQuery(getFoodId)
    console.log("getFoodDetails", getFoodDetails)

    const [foodData, setFoodData] = useState();
    const [getActivet, activeted] = useGetFoodActiveApiMutation()
    const [getVerified, verifiedFood] = useGetFoodVerifiedApiMutation()
    const [getUpdateVarint, updateVarint] = useGetvariantsApiMutation()
    const [getAddVarint, AddVarints] = useGetvariantsApiMutation()
    const [deleteVarint, DeleteVarints] = useGetvariantsDeleteApiMutation()
    const [getFoodDelete, FoodDelete] = useGetFoodDeleteApiMutation()


    useEffect(() => {
        if (getFoodDetails) {
            setFoodData(getFoodDetails?.data);
        }
    }, [getFoodDetails, reLoad]);


    const [foodEdite, setFoodEdite] = useState(null)
    console.log("FoodDetails", foodEdite)
    const [foodAdd, setFoodAdd] = useState(null)
    const [deletFood, setDeleteFood] = useState(null)


    const [openActive, setOpenActive] = useState(false)
    const [openVerified, setOpenVerified] = useState(false)

    const [loadData, setLoadData] = useState(false)
    const [updateVarient, setUpdateVarient] = useState(null)
    const [addVarient, setAddVarinent] = useState(null)
    const [deleteVariant, setDeleteVariant] = useState(false)


    const deleteMessege = useRef()
    const deleteFood = useRef()


    const foodActivet = useRef();
    const activetMassege = useRef();
    const activeteTitele = useRef();
    const foodVerifieds = useRef();
    const verifiedMassege = useRef();
    const verifiedTitele = useRef();

    const deleteMassege = useRef()
    const deleteTitle = useRef()
    const deleteVariants = useRef()






    const onCloseVarinat = () => {
        setDeleteVariant(false)
    }
    const onUpdateVarint = (varient) => {
        setUpdateVarient(varient)
    }
    const onCancleDeleteFood = () => {
        setDeleteFood(false)
    }

    //Food Activet code



    const onShowActivate = (food) => {
        foodActivet.current = food;
        activetMassege.current = `Activete ${food?.name}`
        activeteTitele.current = `Do you want Activete ${food?.name}?`
        setOpenActive(true)
    }

    const onShowDeactivate = (food) => {
        foodActivet.current = food;
        activetMassege.current = `Deactivate ${food?.name}`
        activeteTitele.current = `Do you want deactivate ${food?.name}?`
        setOpenActive(true)
    }

    const handleCloseActive = () => {
        setOpenActive(false)
    }
    const onActivetFood = async () => {
        console.log("activetId", foodActivet.current.active)
        // console.log("activetId", getFoodDetails?.data?.active)
        let status = null
        if (foodActivet.current.active) {
            status = 'D'
        } else {
            status = 'A'
        }

        console.log("Status:", status);
        const body = {
            "food": foodActivet.current.id,
            "status": status
        }
        await getActivet(body)
        setLoadData(true)
        load()
        setOpenActive(false)


    }



    useEffect(() => {
        if (activeted.isSuccess) {
            showSuccess(" Success")
            activeted.reset()
        }
        if (activeted.isError) {
            showError(activeted.error.data.msg)
            activeted.reset()

        }
    }, [activeted, loadData])

    // food veriefyd
    const onShowVerified = (food) => {
        foodVerifieds.current = food;
        verifiedMassege.current = `Verified ${food?.name}`
        verifiedTitele.current = `Do you want Verified food ${food?.name}?`
        setOpenVerified(true)
    }

    const onShowNotVerified = (food) => {
        foodVerifieds.current = food;
        verifiedMassege.current = `Not Verified ${food?.name}`
        verifiedTitele.current = `Do you want not verified food ${food?.name}?`
        setOpenVerified(true)
    }

    const handleCloseVerified = () => {
        setOpenVerified(false)
    }
    const onVerifiedFood = async () => {
        console.log("verified", foodVerifieds.current.verified)
        // console.log("verified", getFoodDetails?.data?.verified)
        let verifieds = null
        if (foodVerifieds.current.verified) {
            verifieds = 'D'
        } else {
            verifieds = 'A'
        }

        console.log("verified:", verifieds);
        const body = {
            "food": foodVerifieds.current.id,
            "status": verifieds
        }
        await getVerified(body)
        load()
        setOpenVerified(false)
    }

    useEffect(() => {
        if (verifiedFood.isSuccess) {
            showSuccess(" Success")
            verifiedFood.reset()
        }
        if (verifiedFood.isError) {
            showError(verifiedFood.error.data.msg)
            verifiedFood.reset()

        }

    }, [verifiedFood, loadData])

    // Add Varinat Code
    const onAddVariant = async (variant,) => {

        const body = {
            "food_id": getFoodId,
            "seller_id": getSellerId,
            "name": variant.name,
            "unit": variant.unit,
            "mrp": variant.mrp,
            "cost": variant.cost,
            "stock": variant.stock,

        }

        try {
            const VarintAdd = await getAddVarint(body)
            setAddVarinent(VarintAdd.variant);
            load()
            setAddVarinent(null)
            setLoadData(true)

        } catch (error) {
            console.log("error", error)
            showError(error || " Some Thing Wrong  !")

        }

    }
    useEffect(() => {
        if (AddVarints.isSuccess) {
            showSuccess("Add Variant Success",)
            AddVarints.reset()
        }
        if (AddVarints.isError) {
            showError('Some Thing Wrong', AddVarints.error.data.msg)
            AddVarints.reset()

        }
    }, [AddVarints,])

    // Update Variant Code 
    const onEditeVariant = async (variant) => {
        const body = {
            "food_id": getFoodId,
            "seller_id": getSellerId,
            "id": variant.id,
            "name": variant.name,
            "unit": variant.unit,
            "mrp": variant.mrp,
            "cost": variant.cost,
            "stock": variant.stock
        }

        try {

            const EditeVarintAdd = await getUpdateVarint(body)
            setUpdateVarient(EditeVarintAdd.variant);
            load()
            setUpdateVarient(null)
            setLoadData(true)

        } catch (error) {
            console.log("error", error)
            showError(error || " Some Thing Wrong  !")
        }

    }


    useEffect(() => {

        if (updateVarint.isSuccess) {
            showSuccess('Food Variant Updated ',)
            updateVarint.reset()

        }
        if (updateVarint.isError) {
            showError('Some Thing Wrong', updateVarint.error.data.msg)
            updateVarint.reset()

        }

    }, [updateVarint, foodVarient])

    // Delete Variant
    const onDeleteVariant = (variant) => {
        console.log('DeletVariant', variant)
        deleteVariants.current = variant.id
        deleteMassege.current = `Delete variant ${variant.name} Kg`
        deleteTitle.current = 'Do you want delete thise variant?'
        setDeleteVariant(variant)
    }

    // deleteVariant Api code
    const onVariantDelete = async () => {
        const body = {
            "food_id": foodData.id,
            "seller_id": getSellerId,
            "varient": deleteVariants.current
        }
        await deleteVarint(body)
        load()
        setLoadData(true)
        setDeleteVariant(null)
    }

    useEffect(() => {
        if (DeleteVarints.isSuccess) {
            showSuccess('Food Variant Delete ! Success',)
            DeleteVarints.reset()
        }
        if (DeleteVarints.isError) {
            showError('Some Thing Wrong', DeleteVarints.error.data.msg)
            DeleteVarints.reset()

        }


    }, [DeleteVarints])

    const onDeleteFood = (product) => {
        deleteTitle.current = "Do You Want Delete Food?"
        deleteFood.current = product.id
        console.log('foodId', product.id)
        deleteMessege.current = `Food ${product.name}`
        setDeleteFood(product)
    }


    // Food Delete code
    const onFoodDelete = async () => {
        const food_id = getFoodId
        const seller_id = getSellerId
        try {
            await getFoodDelete({ seller_id, food_id });
            setDeleteFood(null)
            load()
            // setLoadInfo(true)


        } catch (error) {
            console.error("Error deleting food item", error);
        }
    };

    useEffect(() => {
        if (FoodDelete.isSuccess) {
            showSuccess('Food Delete Success')
            FoodDelete.reset()
        }
        if (FoodDelete.isError) {
            showError(FoodDelete.error.data.msg)
            FoodDelete.reset()
        }

    }, [FoodDelete])

    function mapTypeToLabel(type) {
        switch (type) {
            case "E":
                return "Egge";
            case "V":
                return "Veg";
            case "v":
                return "Veg";
            case "N":
                return "Non-veg";
            default:
                return type;
        }
    }


    return (
        <>
            <Dialog
                open={foodDetail != null}
                onClose={() => { setFoodDetail(null) }}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                fullScreen
            >
                <IconButton
                    edge="start"
                    color="inherit"
                    onClick={() => { setFoodDetail(null) }}
                    aria-label="close"
                    sx={{ alignSelf: 'end' }}
                >
                    <CloseIcon />
                </IconButton>
                <DialogTitle id="alert-dialog-title" sx={{ textAlign: "center" }}>
                    <Typography variant='h6'>
                        {getFoodDetails?.data.name}
                    </Typography>
                    <hr />
                </DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        <Box sx={{ display: "flex", justifyContent: "end" }} mb={3} mt={2}>
                            <Stack direction="row" spacing={2}>
                                <Box>
                                    {foodID?.active ? (
                                        <DeactivateButton food={foodID} onDeactivate={onShowDeactivate} />
                                    ) : (
                                        <ActivateButton food={foodID} onActivate={onShowActivate} />
                                    )}
                                </Box>
                                <Box>
                                    {foodID?.verified ? (
                                        <FoodNotVerified food={foodID} notfoodStatus={onShowVerified} />
                                    ) : (
                                        <FoodVerified food={foodID} foodStatus={onShowNotVerified} />
                                    )}
                                </Box>
                                <Button variant="contained" onClick={() => { setFoodEdite(foodData) }}>Edite Food</Button>
                                <Button variant="contained" color="error" onClick={() => { onDeleteFood(foodData) }}>Delete Food</Button>
                                <Button variant="contained" onClick={setAddVarinent} startIcon={<Iconify icon="eva:plus-fill" />}>
                                    Add Variant
                                </Button>
                            </Stack>
                        </Box>
                        {/* <Typography variant='h6'>kkk</Typography> */}
                    </DialogContentText>
                    {/* <Container maxWidth="xl"> */}
                    <Grid container spacing={2}>
                        <Grid item xs={5}>
                            <Paper
                                sx={{
                                    padding: 2,
                                    display: "flex",
                                    alignItems: "center"
                                }}
                                elevation={3}
                            >


                                <Grid container spacing={2}>
                                    <Grid item xs={5}>
                                        <Stack direction="column" spacing={2}>
                                            <Box >

                                                <DataLogo path={foodData?.thumbnail} />
                                            </Box>
                                            <Box >
                                                <DataLogo path={foodData?.image_1} />

                                            </Box>
                                            <Box >
                                                <DataLogo path={foodData?.image_2} />
                                            </Box>
                                        </Stack>
                                    </Grid>
                                    <Grid item xs={7}>
                                        <Box mt={2}>
                                            <Typography variant="body" color="silver">Name</Typography>
                                            <Typography variant="body1" fontFamily="fantasy">
                                                {foodData?.name}
                                            </Typography>
                                            {/* <hr /> */}
                                            <br />
                                            <Typography variant="body" color="silver">Description</Typography>
                                            <Typography variant="body1" fontFamily="fantasy">
                                                {foodData?.description}
                                            </Typography>
                                            <br />
                                            <Typography variant="body" color="silver">Category</Typography>
                                            <Typography variant="body1" fontFamily="fantasy">
                                                {foodData?.category?.parent?.name}
                                            </Typography>
                                            <br />
                                            <Typography variant="body" color="silver">SubCategory</Typography>
                                            <Typography variant="body1" fontFamily="fantasy">
                                                {foodData?.category?.name}
                                            </Typography>
                                            <br />
                                            <Typography variant="body" color="silver">Type</Typography>
                                            <Typography variant="body1" fontFamily="fantasy">
                                                {mapTypeToLabel(foodData?.type)}
                                            </Typography>
                                            <br />
                                        </Box>
                                    </Grid>
                                </Grid>


                            </Paper>

                        </Grid >
                        <Grid item xs={7}>
                            <VariantTable variants={foodID?.varients} onUpdateVarint={onUpdateVarint} onDeleteVariant={onDeleteVariant} />
                        </Grid>
                    </Grid >
                    {/* </Container > */}

                </DialogContent >
            </Dialog >
            <AlertDialog open={openActive} message={activetMassege} title={activeteTitele} onCancel={handleCloseActive} onOkey={onActivetFood} />
            <UpdateVariant variant={updateVarient} setVariant={setUpdateVarient} varintSubmit={onEditeVariant} />
            <AddVariant setCreateVariant={setAddVarinent} creatvariant={addVarient} varintAdd={onAddVariant} />
            <AlertDialog open={openVerified} message={verifiedMassege} title={verifiedTitele} onCancel={handleCloseVerified} onOkey={onVerifiedFood} />
            <AlertDialog open={deleteVariant} onCancel={onCloseVarinat} message={deleteMassege} title={deleteTitle} onOkey={onVariantDelete} />
            <FoodMenuEdite food={foodEdite} setFood={setFoodEdite} setLoadMenu={setLoadData} reloadData={load} foodDetails={getFoodDetails?.data} />
            <AlertDialog open={deletFood} onCancel={onCancleDeleteFood} onClick={onCancleDeleteFood} message={deleteMessege} title={deleteTitle} onOkey={onFoodDelete} />

        </>
    )
}

export default FoodDeital
